import { FavoritesList, Typography, useNavigate } from '@tunasong/ui-lib'
import type { FC } from 'react'

export interface FavoritiesPateProps {}

export const FavoritiesPage: FC<FavoritiesPateProps> = props => {
  const {} = props
  const navigate = useNavigate()
  return (
    <>
      <Typography variant="h1" align="center" color="text.secondary">
        Favorites
      </Typography>
      <FavoritesList onOpen={f => navigate(f.path)} />
    </>
  )
}
